export interface KriteriaAuditKebersihanRuang {
  no: number;
  kriteria: string;
  dasar_regulasi: string;
}

// 14 item blanko "KEBERSIHAN RUANG RAWAT" (Komite PPI RSPS).
// Single source of truth backend: App\AuditKebersihanRuangSession::KRITERIA
export const KRITERIA_AUDIT_KEBERSIHAN_RUANG: KriteriaAuditKebersihanRuang[] = [
  {
    no: 1,
    kriteria: "Pembersihan permukaan dengan desinfektan standar RS",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 2,
    kriteria:
      "Desinfeksi area keperawatan dengan khlorin 0,05% atau sesuai standar RS",
    dasar_regulasi: "Permenkes 27/2017; CDC Environmental Cleaning"
  },
  {
    no: 3,
    kriteria: "Pembersihan tempat tidur dan kasur pasca pakai",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi lingkungan)"
  },
  {
    no: 4,
    kriteria: "Tempat tidur pasien tidak berdebu",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 5,
    kriteria: "Kasur bersih dan vynil intak / tidak robek",
    dasar_regulasi: "Permenkes 27/2017 (permukaan mudah dibersihkan)"
  },
  {
    no: 6,
    kriteria:
      "Tidak ada sisa makanan atau kotoran menempel di lingkungan pasien",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 7,
    kriteria: "Linen bersih dan rapi",
    dasar_regulasi: "Permenkes 27/2017 (manajemen linen); Permenkes 7/2019"
  },
  {
    no: 8,
    kriteria: "Bantal, restrain bersih",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi lingkungan)"
  },
  {
    no: 9,
    kriteria: "Meja pasien bersih, tidak berdebu, barang seperlunya",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 10,
    kriteria: "Ruang persiapan bersih dan tidak berdebu",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 11,
    kriteria: "Tidak ada sapu ijuk untuk membersihkan ruangan perawatan",
    dasar_regulasi:
      "Permenkes 27/2017 (metode pembersihan basah / wet cleaning)"
  },
  {
    no: 12,
    kriteria: "Tidak ada kemoceng untuk membersihkan ruangan perawatan",
    dasar_regulasi:
      "Permenkes 27/2017 (metode pembersihan basah / wet cleaning)"
  },
  {
    no: 13,
    kriteria:
      "Lingkungan bersih, tidak ada ember penampung atau container yang tidak standar",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 14,
    kriteria: "Mebeler / kursi / sofa tidak ada yang robek",
    dasar_regulasi: "Permenkes 27/2017 (permukaan mudah dibersihkan)"
  }
];

export const KRR_ITEM_COUNT = KRITERIA_AUDIT_KEBERSIHAN_RUANG.length;

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];
